var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "schedule-flow default-content" }, [
    _c(
      "div",
      { staticClass: "schedule-flow__main" },
      [
        _vm.step === 0
          ? _c("schedule-flow-login", {
              attrs: { "account-create-link": _vm.accountCreateLink }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.step === 1
          ? _c("schedule-flow-viewing", {
              attrs: {
                property: _vm.property,
                subscription: _vm.subscription,
                agendaRoute: _vm.agendaRoute,
                route: _vm.route,
                "edit-route": _vm.editRoute,
                excludedDays: _vm.excludedDays,
                excludedDates: _vm.excludedDates
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.step === 2
          ? _c("schedule-flow-confirmation", {
              attrs: { subscription: _vm.subscription }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.step === 2
          ? _c(
              "a",
              {
                staticClass: "theme-btn theme-btn--text hidden lg:inline-flex",
                attrs: { href: "/" }
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.locales.common && _vm.locales.common.go_to_home_page
                    ) +
                    "\n      "
                ),
                _c("i", { staticClass: "icon-go-right" })
              ]
            )
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "schedule-flow__side mb-10" }, [
      _c("div", { staticClass: "schedule-flow__apartment" }, [
        _c("div", { staticClass: "schedule-flow__apartment-topic" }, [
          _c("div", { staticClass: "schedule-flow__apartment-image-holder" }, [
            _c("img", {
              staticClass: "schedule-flow__apartment-image",
              attrs: { src: _vm.property.mainPhoto, alt: "photo" }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "schedule-flow__apartment-heading" }, [
            _c("div", { staticClass: "schedule-flow__apartment-name" }, [
              _vm._v(_vm._s(_vm.property.listingAddress))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "schedule-flow__apartment-address" }, [
              _vm._v(
                _vm._s(_vm.property.postcode) +
                  ", " +
                  _vm._s(_vm.property.location)
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.step <= 1
          ? _c("div", { staticClass: "schedule-flow__apartment-info" }, [
              _c(
                "div",
                { staticClass: "schedule-flow__apartment-info-title" },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.locales.properties &&
                          _vm.locales.properties.price_details
                      ) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "schedule-flow__apartment-info-area" }, [
                _c(
                  "div",
                  { staticClass: "schedule-flow__apartment-info-row" },
                  [
                    _c(
                      "span",
                      { staticClass: "schedule-flow__apartment-info-item" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.locales.properties &&
                              _vm.locales.properties.price
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "schedule-flow__apartment-info-item" },
                      [_vm._v("€ " + _vm._s(_vm.property.ah_price))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "schedule-flow__apartment-info-row" },
                  [
                    _c(
                      "span",
                      { staticClass: "schedule-flow__apartment-info-item" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.locales.property && _vm.locales.property.deposit
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "schedule-flow__apartment-info-item" },
                      [
                        _vm._v(
                          "€ " +
                            _vm._s(
                              _vm.property.depositAmount
                                ? _vm.property.depositAmount
                                : 0
                            )
                        )
                      ]
                    )
                  ]
                )
              ])
            ])
          : _c("div", { staticClass: "schedule-flow__apartment-contact" }, [
              _c(
                "div",
                { staticClass: "schedule-flow__apartment-contact-row" },
                [
                  _c(
                    "span",
                    { staticClass: "schedule-flow__apartment-contact-title" },
                    [_vm._v("\n              Contact host\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "schedule-flow__apartment-contact-actions" },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "mailto:" + _vm.property.landlord.email
                          }
                        },
                        [_c("i", { staticClass: "icon-mail" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "tel:" + _vm.property.landlord.phone_number
                          }
                        },
                        [_c("i", { staticClass: "icon-phone" })]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "theme-btn theme-btn--block theme-btn--destructive",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.cancel.apply(null, arguments)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.locales.appointments &&
                          _vm.locales.appointments.cancel_viewing
                      ) +
                      "\n        "
                  )
                ]
              )
            ])
      ])
    ]),
    _vm._v(" "),
    _vm.step === 2
      ? _c("div", { staticClass: "flex justify-center lg:hidden" }, [
          _c(
            "a",
            { staticClass: "theme-btn theme-btn--text", attrs: { href: "/" } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.locales.common && _vm.locales.common.go_to_home_page
                  ) +
                  "\n      "
              ),
              _c("i", { staticClass: "icon-go-right" })
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73af9dd0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73af9dd0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/ScheduleFlow.vue
// module id = 689
// module chunks = 1